export enum ResetTypes {
    ThriveVideo,
    ThriveAudio,
    Personalized
}
